<template xmlns="http://www.w3.org/1999/html">
  <div class="d-flex flex-column email-login">
    <div class="text-center">
      <h1>{{ $t('login_with_email')}}</h1>
    </div>
    <div class="d-flex flex-column gap-sm">
      <div class="">
        <label for="email" class="form-label text-capitalize-first">{{ $t('email') }}</label>
        <input v-model="state.email" id="email" type="email" class="form-control" :placeholder="$t('enter_email')">
      </div>
      <div class="">
        <label for="password" class="form-label text-capitalize-first">{{ $t('password') }}</label>
        <input v-model="state.password" id="password" type="password" class="form-control" :placeholder="$t('enter_password')">
      </div>
    </div>
    <div class="d-flex flex-column text-center">
      <router-link :to="{name:'forgotPassword'}">{{$t('forgot_password')}}</router-link>
    </div>
    <div>
      <button @click.prevent="login()" class="btn btn-primary w-100 btn-lg"><span class="text-capitalize-first">{{$t('login')}}</span></button>
    </div>
    <div class="text-center">
      <router-link :to="{name:'registration'}"><span>{{$t('dont_have_account')}}</span> <span class="register-here">{{$t('register_here')}}</span></router-link>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import {onMounted} from "vue";
import {useStore} from "vuex";
import TokenGetRequestDTO from "@/models/request/TokenGetRequestDTO";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";

const state = reactive({
  password: '' as string,
  email: '' as string
});

const store = useStore()
const notification = useNotification()

const login = async () => {
  try {
    const token = await api.call.token.get({ username: state.email, password: state.password } as TokenGetRequestDTO)
    await store.dispatch('authenticate', token)
    window.location.href = '/'
  } catch (e: any) {
    if (e.response?.data?.[0]?.code === 'EMAIL_NOT_VERIFIED') {
      notification.notify({type: 'error', title: $t('notifications.email_not_verified'), duration: 3000})
    } else {
      notification.notify({type: 'error', title: $t('notifications.incorrect_email_or_password'), duration: 1500})
    }
  }
}

onMounted(async () => {
})

</script>
